import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeCompensationDetailService = (params: {
  id?: string;
  employeeId?: number;
}) =>
  RestAPIClient.call<Types.EmployeeCompensation>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeCompensationHistoryListService = (
  params: Types.CompensationHistoryListRequest
) =>
  RestAPIClient.call<Types.CompensationHistoryListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.HistoryList,
    config: {
      requireAuthentication: true,
      params,
    },
  });
